export default {
  yellow: "#FFEB3B",
  white: "#fff",
  text: "#333",
  gray: "#616161"
};



// WEBPACK FOOTER //
// ./src/config/colors.js